/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as AppRouteImport } from './../routes/_app'
import { Route as DesignRouteImport } from './../routes/design'
import { Route as LoginRouteImport } from './../routes/login'
import { Route as AppIndexRouteImport } from './../routes/_app/index'
import { Route as AppApprovalsRouteImport } from './../routes/_app/approvals'
import { Route as AppPlanningRouteImport } from './../routes/_app/planning'
import { Route as AppReportsRouteImport } from './../routes/_app/reports'
import { Route as AppCatalogueIndexRouteImport } from './../routes/_app/catalogue/index'
import { Route as AppCatalogueProductIdRouteImport } from './../routes/_app/catalogue/$productId'
import { Route as AppCatalogueReviewRouteImport } from './../routes/_app/catalogue/review'
import { Route as AppImportsIndexRouteImport } from './../routes/_app/imports/index'
import { Route as AppImportsConnectRouteImport } from './../routes/_app/imports/connect'
import { Route as AppImportsRulesRouteImport } from './../routes/_app/imports/rules'
import { Route as AppOrdersIndexRouteImport } from './../routes/_app/orders/index'
import { Route as AppOrdersNewRouteImport } from './../routes/_app/orders/new'
import { Route as AppProductionIndexRouteImport } from './../routes/_app/production/index'
import { Route as AppProductionBatchIdRouteImport } from './../routes/_app/production/$batchId'
import { Route as AppProductionReportsRouteImport } from './../routes/_app/production/reports'
import { Route as AppPurchasingIndexRouteImport } from './../routes/_app/purchasing/index'
import { Route as AppRecipesIndexRouteImport } from './../routes/_app/recipes/index'
import { Route as AppRecipesNewRouteImport } from './../routes/_app/recipes/new'
import { Route as AppReplayIndexRouteImport } from './../routes/_app/replay/index'
import { Route as AppReplayNewRouteImport } from './../routes/_app/replay/new'
import { Route as AppSalesIndexRouteImport } from './../routes/_app/sales/index'
import { Route as AppSalesTicketIdRouteImport } from './../routes/_app/sales/$ticketId'
import { Route as AppSettingsIndexRouteImport } from './../routes/_app/settings/index'
import { Route as AppSettingsRolesRouteImport } from './../routes/_app/settings/roles'
import { Route as AppSettingsStaffRouteImport } from './../routes/_app/settings/staff'
import { Route as AppSettingsStationsRouteImport } from './../routes/_app/settings/stations'
import { Route as AppSettingsStockControlRouteImport } from './../routes/_app/settings/stock-control'
import { Route as AppStockIndexRouteImport } from './../routes/_app/stock/index'
import { Route as AppStockProductIdRouteImport } from './../routes/_app/stock/$productId'
import { Route as AppStockExpiryRouteImport } from './../routes/_app/stock/expiry'
import { Route as AppStockMovementsRouteImport } from './../routes/_app/stock/movements'
import { Route as AppStockWriteOffsRouteImport } from './../routes/_app/stock/write-offs'
import { Route as AppOrdersOrderIdIndexRouteImport } from './../routes/_app/orders/$orderId/index'
import { Route as AppOrdersOrderIdEditRouteImport } from './../routes/_app/orders/$orderId/edit'
import { Route as AppPurchasingOrdersOrderIdRouteImport } from './../routes/_app/purchasing/orders/$orderId'
import { Route as AppPurchasingPriceListsPriceListIdRouteImport } from './../routes/_app/purchasing/price-lists/$priceListId'
import { Route as AppPurchasingReceiptsIndexRouteImport } from './../routes/_app/purchasing/receipts/index'
import { Route as AppPurchasingReceiptsReceiptIdRouteImport } from './../routes/_app/purchasing/receipts/$receiptId'
import { Route as AppPurchasingRequestsIndexRouteImport } from './../routes/_app/purchasing/requests/index'
import { Route as AppPurchasingRequestsRequestIdRouteImport } from './../routes/_app/purchasing/requests/$requestId'
import { Route as AppPurchasingRequestsNewRouteImport } from './../routes/_app/purchasing/requests/new'
import { Route as AppPurchasingRestockIndexRouteImport } from './../routes/_app/purchasing/restock/index'
import { Route as AppPurchasingRestockLevelsRouteImport } from './../routes/_app/purchasing/restock/levels'
import { Route as AppPurchasingSuppliersIndexRouteImport } from './../routes/_app/purchasing/suppliers/index'
import { Route as AppRecipesRecipeIdIndexRouteImport } from './../routes/_app/recipes/$recipeId/index'
import { Route as AppRecipesCostsIndexRouteImport } from './../routes/_app/recipes/costs/index'
import { Route as AppRecipesCostsProductIdRouteImport } from './../routes/_app/recipes/costs/$productId'
import { Route as AppReplayRunsRunIdRouteImport } from './../routes/_app/replay/runs/$runId'
import { Route as AppSettingsHeldActionsIndexRouteImport } from './../routes/_app/settings/held-actions/index'
import { Route as AppSettingsHeldActionsHoldIdRouteImport } from './../routes/_app/settings/held-actions/$holdId'
import { Route as AppSettingsRejectedActionsIndexRouteImport } from './../routes/_app/settings/rejected-actions/index'
import { Route as AppSettingsRejectedActionsCommandIdRouteImport } from './../routes/_app/settings/rejected-actions/$commandId'
import { Route as AppStockCountsIndexRouteImport } from './../routes/_app/stock/counts/index'
import { Route as AppStockCountsCountIdRouteImport } from './../routes/_app/stock/counts/$countId'
import { Route as AppImportsRunsRunIdIndexRouteImport } from './../routes/_app/imports/runs/$runId/index'
import { Route as AppImportsRunsRunIdRecordsRouteImport } from './../routes/_app/imports/runs/$runId/records'
import { Route as AppImportsRunsRunIdReviewRouteImport } from './../routes/_app/imports/runs/$runId/review'
import { Route as AppPurchasingSuppliersSupplierIdIndexRouteImport } from './../routes/_app/purchasing/suppliers/$supplierId/index'
import { Route as AppRecipesRecipeIdVersionsVersionIdRouteImport } from './../routes/_app/recipes/$recipeId/versions/$versionId'
import { Route as AppPurchasingSuppliersSupplierIdPriceListsNewRouteImport } from './../routes/_app/purchasing/suppliers/$supplierId/price-lists/new'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignRoute = DesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsRoute = AppApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppPlanningRoute = AppPlanningRouteImport.update({
  id: '/planning',
  path: '/planning',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogueIndexRoute = AppCatalogueIndexRouteImport.update({
  id: '/catalogue/',
  path: '/catalogue/',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogueProductIdRoute = AppCatalogueProductIdRouteImport.update({
  id: '/catalogue/$productId',
  path: '/catalogue/$productId',
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogueReviewRoute = AppCatalogueReviewRouteImport.update({
  id: '/catalogue/review',
  path: '/catalogue/review',
  getParentRoute: () => AppRoute,
} as any)
const AppImportsIndexRoute = AppImportsIndexRouteImport.update({
  id: '/imports/',
  path: '/imports/',
  getParentRoute: () => AppRoute,
} as any)
const AppImportsConnectRoute = AppImportsConnectRouteImport.update({
  id: '/imports/connect',
  path: '/imports/connect',
  getParentRoute: () => AppRoute,
} as any)
const AppImportsRulesRoute = AppImportsRulesRouteImport.update({
  id: '/imports/rules',
  path: '/imports/rules',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersNewRoute = AppOrdersNewRouteImport.update({
  id: '/orders/new',
  path: '/orders/new',
  getParentRoute: () => AppRoute,
} as any)
const AppProductionIndexRoute = AppProductionIndexRouteImport.update({
  id: '/production/',
  path: '/production/',
  getParentRoute: () => AppRoute,
} as any)
const AppProductionBatchIdRoute = AppProductionBatchIdRouteImport.update({
  id: '/production/$batchId',
  path: '/production/$batchId',
  getParentRoute: () => AppRoute,
} as any)
const AppProductionReportsRoute = AppProductionReportsRouteImport.update({
  id: '/production/reports',
  path: '/production/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingIndexRoute = AppPurchasingIndexRouteImport.update({
  id: '/purchasing/',
  path: '/purchasing/',
  getParentRoute: () => AppRoute,
} as any)
const AppRecipesIndexRoute = AppRecipesIndexRouteImport.update({
  id: '/recipes/',
  path: '/recipes/',
  getParentRoute: () => AppRoute,
} as any)
const AppRecipesNewRoute = AppRecipesNewRouteImport.update({
  id: '/recipes/new',
  path: '/recipes/new',
  getParentRoute: () => AppRoute,
} as any)
const AppReplayIndexRoute = AppReplayIndexRouteImport.update({
  id: '/replay/',
  path: '/replay/',
  getParentRoute: () => AppRoute,
} as any)
const AppReplayNewRoute = AppReplayNewRouteImport.update({
  id: '/replay/new',
  path: '/replay/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesIndexRoute = AppSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => AppRoute,
} as any)
const AppSalesTicketIdRoute = AppSalesTicketIdRouteImport.update({
  id: '/sales/$ticketId',
  path: '/sales/$ticketId',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRolesRoute = AppSettingsRolesRouteImport.update({
  id: '/settings/roles',
  path: '/settings/roles',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsStaffRoute = AppSettingsStaffRouteImport.update({
  id: '/settings/staff',
  path: '/settings/staff',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsStationsRoute = AppSettingsStationsRouteImport.update({
  id: '/settings/stations',
  path: '/settings/stations',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsStockControlRoute = AppSettingsStockControlRouteImport.update({
  id: '/settings/stock-control',
  path: '/settings/stock-control',
  getParentRoute: () => AppRoute,
} as any)
const AppStockIndexRoute = AppStockIndexRouteImport.update({
  id: '/stock/',
  path: '/stock/',
  getParentRoute: () => AppRoute,
} as any)
const AppStockProductIdRoute = AppStockProductIdRouteImport.update({
  id: '/stock/$productId',
  path: '/stock/$productId',
  getParentRoute: () => AppRoute,
} as any)
const AppStockExpiryRoute = AppStockExpiryRouteImport.update({
  id: '/stock/expiry',
  path: '/stock/expiry',
  getParentRoute: () => AppRoute,
} as any)
const AppStockMovementsRoute = AppStockMovementsRouteImport.update({
  id: '/stock/movements',
  path: '/stock/movements',
  getParentRoute: () => AppRoute,
} as any)
const AppStockWriteOffsRoute = AppStockWriteOffsRouteImport.update({
  id: '/stock/write-offs',
  path: '/stock/write-offs',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersOrderIdIndexRoute = AppOrdersOrderIdIndexRouteImport.update({
  id: '/orders/$orderId/',
  path: '/orders/$orderId/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersOrderIdEditRoute = AppOrdersOrderIdEditRouteImport.update({
  id: '/orders/$orderId/edit',
  path: '/orders/$orderId/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppPurchasingOrdersOrderIdRoute =
  AppPurchasingOrdersOrderIdRouteImport.update({
    id: '/purchasing/orders/$orderId',
    path: '/purchasing/orders/$orderId',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingPriceListsPriceListIdRoute =
  AppPurchasingPriceListsPriceListIdRouteImport.update({
    id: '/purchasing/price-lists/$priceListId',
    path: '/purchasing/price-lists/$priceListId',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingReceiptsIndexRoute =
  AppPurchasingReceiptsIndexRouteImport.update({
    id: '/purchasing/receipts/',
    path: '/purchasing/receipts/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingReceiptsReceiptIdRoute =
  AppPurchasingReceiptsReceiptIdRouteImport.update({
    id: '/purchasing/receipts/$receiptId',
    path: '/purchasing/receipts/$receiptId',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingRequestsIndexRoute =
  AppPurchasingRequestsIndexRouteImport.update({
    id: '/purchasing/requests/',
    path: '/purchasing/requests/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingRequestsRequestIdRoute =
  AppPurchasingRequestsRequestIdRouteImport.update({
    id: '/purchasing/requests/$requestId',
    path: '/purchasing/requests/$requestId',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingRequestsNewRoute =
  AppPurchasingRequestsNewRouteImport.update({
    id: '/purchasing/requests/new',
    path: '/purchasing/requests/new',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingRestockIndexRoute =
  AppPurchasingRestockIndexRouteImport.update({
    id: '/purchasing/restock/',
    path: '/purchasing/restock/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingRestockLevelsRoute =
  AppPurchasingRestockLevelsRouteImport.update({
    id: '/purchasing/restock/levels',
    path: '/purchasing/restock/levels',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingSuppliersIndexRoute =
  AppPurchasingSuppliersIndexRouteImport.update({
    id: '/purchasing/suppliers/',
    path: '/purchasing/suppliers/',
    getParentRoute: () => AppRoute,
  } as any)
const AppRecipesRecipeIdIndexRoute = AppRecipesRecipeIdIndexRouteImport.update({
  id: '/recipes/$recipeId/',
  path: '/recipes/$recipeId/',
  getParentRoute: () => AppRoute,
} as any)
const AppRecipesCostsIndexRoute = AppRecipesCostsIndexRouteImport.update({
  id: '/recipes/costs/',
  path: '/recipes/costs/',
  getParentRoute: () => AppRoute,
} as any)
const AppRecipesCostsProductIdRoute =
  AppRecipesCostsProductIdRouteImport.update({
    id: '/recipes/costs/$productId',
    path: '/recipes/costs/$productId',
    getParentRoute: () => AppRoute,
  } as any)
const AppReplayRunsRunIdRoute = AppReplayRunsRunIdRouteImport.update({
  id: '/replay/runs/$runId',
  path: '/replay/runs/$runId',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsHeldActionsIndexRoute =
  AppSettingsHeldActionsIndexRouteImport.update({
    id: '/settings/held-actions/',
    path: '/settings/held-actions/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsHeldActionsHoldIdRoute =
  AppSettingsHeldActionsHoldIdRouteImport.update({
    id: '/settings/held-actions/$holdId',
    path: '/settings/held-actions/$holdId',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsRejectedActionsIndexRoute =
  AppSettingsRejectedActionsIndexRouteImport.update({
    id: '/settings/rejected-actions/',
    path: '/settings/rejected-actions/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsRejectedActionsCommandIdRoute =
  AppSettingsRejectedActionsCommandIdRouteImport.update({
    id: '/settings/rejected-actions/$commandId',
    path: '/settings/rejected-actions/$commandId',
    getParentRoute: () => AppRoute,
  } as any)
const AppStockCountsIndexRoute = AppStockCountsIndexRouteImport.update({
  id: '/stock/counts/',
  path: '/stock/counts/',
  getParentRoute: () => AppRoute,
} as any)
const AppStockCountsCountIdRoute = AppStockCountsCountIdRouteImport.update({
  id: '/stock/counts/$countId',
  path: '/stock/counts/$countId',
  getParentRoute: () => AppRoute,
} as any)
const AppImportsRunsRunIdIndexRoute =
  AppImportsRunsRunIdIndexRouteImport.update({
    id: '/imports/runs/$runId/',
    path: '/imports/runs/$runId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppImportsRunsRunIdRecordsRoute =
  AppImportsRunsRunIdRecordsRouteImport.update({
    id: '/imports/runs/$runId/records',
    path: '/imports/runs/$runId/records',
    getParentRoute: () => AppRoute,
  } as any)
const AppImportsRunsRunIdReviewRoute =
  AppImportsRunsRunIdReviewRouteImport.update({
    id: '/imports/runs/$runId/review',
    path: '/imports/runs/$runId/review',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingSuppliersSupplierIdIndexRoute =
  AppPurchasingSuppliersSupplierIdIndexRouteImport.update({
    id: '/purchasing/suppliers/$supplierId/',
    path: '/purchasing/suppliers/$supplierId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppRecipesRecipeIdVersionsVersionIdRoute =
  AppRecipesRecipeIdVersionsVersionIdRouteImport.update({
    id: '/recipes/$recipeId/versions/$versionId',
    path: '/recipes/$recipeId/versions/$versionId',
    getParentRoute: () => AppRoute,
  } as any)
const AppPurchasingSuppliersSupplierIdPriceListsNewRoute =
  AppPurchasingSuppliersSupplierIdPriceListsNewRouteImport.update({
    id: '/purchasing/suppliers/$supplierId/price-lists/new',
    path: '/purchasing/suppliers/$supplierId/price-lists/new',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/design': typeof DesignRoute
  '/login': typeof LoginRoute
  '/approvals': typeof AppApprovalsRoute
  '/planning': typeof AppPlanningRoute
  '/reports': typeof AppReportsRoute
  '/catalogue/$productId': typeof AppCatalogueProductIdRoute
  '/catalogue/review': typeof AppCatalogueReviewRoute
  '/imports/connect': typeof AppImportsConnectRoute
  '/imports/rules': typeof AppImportsRulesRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/production/$batchId': typeof AppProductionBatchIdRoute
  '/production/reports': typeof AppProductionReportsRoute
  '/recipes/new': typeof AppRecipesNewRoute
  '/replay/new': typeof AppReplayNewRoute
  '/sales/$ticketId': typeof AppSalesTicketIdRoute
  '/settings/roles': typeof AppSettingsRolesRoute
  '/settings/staff': typeof AppSettingsStaffRoute
  '/settings/stations': typeof AppSettingsStationsRoute
  '/settings/stock-control': typeof AppSettingsStockControlRoute
  '/stock/$productId': typeof AppStockProductIdRoute
  '/stock/expiry': typeof AppStockExpiryRoute
  '/stock/movements': typeof AppStockMovementsRoute
  '/stock/write-offs': typeof AppStockWriteOffsRoute
  '/catalogue/': typeof AppCatalogueIndexRoute
  '/imports/': typeof AppImportsIndexRoute
  '/orders/': typeof AppOrdersIndexRoute
  '/production/': typeof AppProductionIndexRoute
  '/purchasing/': typeof AppPurchasingIndexRoute
  '/recipes/': typeof AppRecipesIndexRoute
  '/replay/': typeof AppReplayIndexRoute
  '/sales/': typeof AppSalesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/stock/': typeof AppStockIndexRoute
  '/orders/$orderId/edit': typeof AppOrdersOrderIdEditRoute
  '/purchasing/orders/$orderId': typeof AppPurchasingOrdersOrderIdRoute
  '/purchasing/price-lists/$priceListId': typeof AppPurchasingPriceListsPriceListIdRoute
  '/purchasing/receipts/$receiptId': typeof AppPurchasingReceiptsReceiptIdRoute
  '/purchasing/requests/$requestId': typeof AppPurchasingRequestsRequestIdRoute
  '/purchasing/requests/new': typeof AppPurchasingRequestsNewRoute
  '/purchasing/restock/levels': typeof AppPurchasingRestockLevelsRoute
  '/recipes/costs/$productId': typeof AppRecipesCostsProductIdRoute
  '/replay/runs/$runId': typeof AppReplayRunsRunIdRoute
  '/settings/held-actions/$holdId': typeof AppSettingsHeldActionsHoldIdRoute
  '/settings/rejected-actions/$commandId': typeof AppSettingsRejectedActionsCommandIdRoute
  '/stock/counts/$countId': typeof AppStockCountsCountIdRoute
  '/orders/$orderId/': typeof AppOrdersOrderIdIndexRoute
  '/purchasing/receipts/': typeof AppPurchasingReceiptsIndexRoute
  '/purchasing/requests/': typeof AppPurchasingRequestsIndexRoute
  '/purchasing/restock/': typeof AppPurchasingRestockIndexRoute
  '/purchasing/suppliers/': typeof AppPurchasingSuppliersIndexRoute
  '/recipes/$recipeId/': typeof AppRecipesRecipeIdIndexRoute
  '/recipes/costs/': typeof AppRecipesCostsIndexRoute
  '/settings/held-actions/': typeof AppSettingsHeldActionsIndexRoute
  '/settings/rejected-actions/': typeof AppSettingsRejectedActionsIndexRoute
  '/stock/counts/': typeof AppStockCountsIndexRoute
  '/imports/runs/$runId/records': typeof AppImportsRunsRunIdRecordsRoute
  '/imports/runs/$runId/review': typeof AppImportsRunsRunIdReviewRoute
  '/recipes/$recipeId/versions/$versionId': typeof AppRecipesRecipeIdVersionsVersionIdRoute
  '/imports/runs/$runId/': typeof AppImportsRunsRunIdIndexRoute
  '/purchasing/suppliers/$supplierId/': typeof AppPurchasingSuppliersSupplierIdIndexRoute
  '/purchasing/suppliers/$supplierId/price-lists/new': typeof AppPurchasingSuppliersSupplierIdPriceListsNewRoute
}
export interface FileRoutesByTo {
  '/design': typeof DesignRoute
  '/login': typeof LoginRoute
  '/approvals': typeof AppApprovalsRoute
  '/planning': typeof AppPlanningRoute
  '/reports': typeof AppReportsRoute
  '/': typeof AppIndexRoute
  '/catalogue/$productId': typeof AppCatalogueProductIdRoute
  '/catalogue/review': typeof AppCatalogueReviewRoute
  '/imports/connect': typeof AppImportsConnectRoute
  '/imports/rules': typeof AppImportsRulesRoute
  '/orders/new': typeof AppOrdersNewRoute
  '/production/$batchId': typeof AppProductionBatchIdRoute
  '/production/reports': typeof AppProductionReportsRoute
  '/recipes/new': typeof AppRecipesNewRoute
  '/replay/new': typeof AppReplayNewRoute
  '/sales/$ticketId': typeof AppSalesTicketIdRoute
  '/settings/roles': typeof AppSettingsRolesRoute
  '/settings/staff': typeof AppSettingsStaffRoute
  '/settings/stations': typeof AppSettingsStationsRoute
  '/settings/stock-control': typeof AppSettingsStockControlRoute
  '/stock/$productId': typeof AppStockProductIdRoute
  '/stock/expiry': typeof AppStockExpiryRoute
  '/stock/movements': typeof AppStockMovementsRoute
  '/stock/write-offs': typeof AppStockWriteOffsRoute
  '/catalogue': typeof AppCatalogueIndexRoute
  '/imports': typeof AppImportsIndexRoute
  '/orders': typeof AppOrdersIndexRoute
  '/production': typeof AppProductionIndexRoute
  '/purchasing': typeof AppPurchasingIndexRoute
  '/recipes': typeof AppRecipesIndexRoute
  '/replay': typeof AppReplayIndexRoute
  '/sales': typeof AppSalesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/stock': typeof AppStockIndexRoute
  '/orders/$orderId/edit': typeof AppOrdersOrderIdEditRoute
  '/purchasing/orders/$orderId': typeof AppPurchasingOrdersOrderIdRoute
  '/purchasing/price-lists/$priceListId': typeof AppPurchasingPriceListsPriceListIdRoute
  '/purchasing/receipts/$receiptId': typeof AppPurchasingReceiptsReceiptIdRoute
  '/purchasing/requests/$requestId': typeof AppPurchasingRequestsRequestIdRoute
  '/purchasing/requests/new': typeof AppPurchasingRequestsNewRoute
  '/purchasing/restock/levels': typeof AppPurchasingRestockLevelsRoute
  '/recipes/costs/$productId': typeof AppRecipesCostsProductIdRoute
  '/replay/runs/$runId': typeof AppReplayRunsRunIdRoute
  '/settings/held-actions/$holdId': typeof AppSettingsHeldActionsHoldIdRoute
  '/settings/rejected-actions/$commandId': typeof AppSettingsRejectedActionsCommandIdRoute
  '/stock/counts/$countId': typeof AppStockCountsCountIdRoute
  '/orders/$orderId': typeof AppOrdersOrderIdIndexRoute
  '/purchasing/receipts': typeof AppPurchasingReceiptsIndexRoute
  '/purchasing/requests': typeof AppPurchasingRequestsIndexRoute
  '/purchasing/restock': typeof AppPurchasingRestockIndexRoute
  '/purchasing/suppliers': typeof AppPurchasingSuppliersIndexRoute
  '/recipes/$recipeId': typeof AppRecipesRecipeIdIndexRoute
  '/recipes/costs': typeof AppRecipesCostsIndexRoute
  '/settings/held-actions': typeof AppSettingsHeldActionsIndexRoute
  '/settings/rejected-actions': typeof AppSettingsRejectedActionsIndexRoute
  '/stock/counts': typeof AppStockCountsIndexRoute
  '/imports/runs/$runId/records': typeof AppImportsRunsRunIdRecordsRoute
  '/imports/runs/$runId/review': typeof AppImportsRunsRunIdReviewRoute
  '/recipes/$recipeId/versions/$versionId': typeof AppRecipesRecipeIdVersionsVersionIdRoute
  '/imports/runs/$runId': typeof AppImportsRunsRunIdIndexRoute
  '/purchasing/suppliers/$supplierId': typeof AppPurchasingSuppliersSupplierIdIndexRoute
  '/purchasing/suppliers/$supplierId/price-lists/new': typeof AppPurchasingSuppliersSupplierIdPriceListsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/design': typeof DesignRoute
  '/login': typeof LoginRoute
  '/_app/approvals': typeof AppApprovalsRoute
  '/_app/planning': typeof AppPlanningRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/catalogue/$productId': typeof AppCatalogueProductIdRoute
  '/_app/catalogue/review': typeof AppCatalogueReviewRoute
  '/_app/imports/connect': typeof AppImportsConnectRoute
  '/_app/imports/rules': typeof AppImportsRulesRoute
  '/_app/orders/new': typeof AppOrdersNewRoute
  '/_app/production/$batchId': typeof AppProductionBatchIdRoute
  '/_app/production/reports': typeof AppProductionReportsRoute
  '/_app/recipes/new': typeof AppRecipesNewRoute
  '/_app/replay/new': typeof AppReplayNewRoute
  '/_app/sales/$ticketId': typeof AppSalesTicketIdRoute
  '/_app/settings/roles': typeof AppSettingsRolesRoute
  '/_app/settings/staff': typeof AppSettingsStaffRoute
  '/_app/settings/stations': typeof AppSettingsStationsRoute
  '/_app/settings/stock-control': typeof AppSettingsStockControlRoute
  '/_app/stock/$productId': typeof AppStockProductIdRoute
  '/_app/stock/expiry': typeof AppStockExpiryRoute
  '/_app/stock/movements': typeof AppStockMovementsRoute
  '/_app/stock/write-offs': typeof AppStockWriteOffsRoute
  '/_app/catalogue/': typeof AppCatalogueIndexRoute
  '/_app/imports/': typeof AppImportsIndexRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
  '/_app/production/': typeof AppProductionIndexRoute
  '/_app/purchasing/': typeof AppPurchasingIndexRoute
  '/_app/recipes/': typeof AppRecipesIndexRoute
  '/_app/replay/': typeof AppReplayIndexRoute
  '/_app/sales/': typeof AppSalesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/stock/': typeof AppStockIndexRoute
  '/_app/orders/$orderId/edit': typeof AppOrdersOrderIdEditRoute
  '/_app/purchasing/orders/$orderId': typeof AppPurchasingOrdersOrderIdRoute
  '/_app/purchasing/price-lists/$priceListId': typeof AppPurchasingPriceListsPriceListIdRoute
  '/_app/purchasing/receipts/$receiptId': typeof AppPurchasingReceiptsReceiptIdRoute
  '/_app/purchasing/requests/$requestId': typeof AppPurchasingRequestsRequestIdRoute
  '/_app/purchasing/requests/new': typeof AppPurchasingRequestsNewRoute
  '/_app/purchasing/restock/levels': typeof AppPurchasingRestockLevelsRoute
  '/_app/recipes/costs/$productId': typeof AppRecipesCostsProductIdRoute
  '/_app/replay/runs/$runId': typeof AppReplayRunsRunIdRoute
  '/_app/settings/held-actions/$holdId': typeof AppSettingsHeldActionsHoldIdRoute
  '/_app/settings/rejected-actions/$commandId': typeof AppSettingsRejectedActionsCommandIdRoute
  '/_app/stock/counts/$countId': typeof AppStockCountsCountIdRoute
  '/_app/orders/$orderId/': typeof AppOrdersOrderIdIndexRoute
  '/_app/purchasing/receipts/': typeof AppPurchasingReceiptsIndexRoute
  '/_app/purchasing/requests/': typeof AppPurchasingRequestsIndexRoute
  '/_app/purchasing/restock/': typeof AppPurchasingRestockIndexRoute
  '/_app/purchasing/suppliers/': typeof AppPurchasingSuppliersIndexRoute
  '/_app/recipes/$recipeId/': typeof AppRecipesRecipeIdIndexRoute
  '/_app/recipes/costs/': typeof AppRecipesCostsIndexRoute
  '/_app/settings/held-actions/': typeof AppSettingsHeldActionsIndexRoute
  '/_app/settings/rejected-actions/': typeof AppSettingsRejectedActionsIndexRoute
  '/_app/stock/counts/': typeof AppStockCountsIndexRoute
  '/_app/imports/runs/$runId/records': typeof AppImportsRunsRunIdRecordsRoute
  '/_app/imports/runs/$runId/review': typeof AppImportsRunsRunIdReviewRoute
  '/_app/recipes/$recipeId/versions/$versionId': typeof AppRecipesRecipeIdVersionsVersionIdRoute
  '/_app/imports/runs/$runId/': typeof AppImportsRunsRunIdIndexRoute
  '/_app/purchasing/suppliers/$supplierId/': typeof AppPurchasingSuppliersSupplierIdIndexRoute
  '/_app/purchasing/suppliers/$supplierId/price-lists/new': typeof AppPurchasingSuppliersSupplierIdPriceListsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/design'
    | '/login'
    | '/approvals'
    | '/planning'
    | '/reports'
    | '/catalogue/$productId'
    | '/catalogue/review'
    | '/imports/connect'
    | '/imports/rules'
    | '/orders/new'
    | '/production/$batchId'
    | '/production/reports'
    | '/recipes/new'
    | '/replay/new'
    | '/sales/$ticketId'
    | '/settings/roles'
    | '/settings/staff'
    | '/settings/stations'
    | '/settings/stock-control'
    | '/stock/$productId'
    | '/stock/expiry'
    | '/stock/movements'
    | '/stock/write-offs'
    | '/catalogue/'
    | '/imports/'
    | '/orders/'
    | '/production/'
    | '/purchasing/'
    | '/recipes/'
    | '/replay/'
    | '/sales/'
    | '/settings/'
    | '/stock/'
    | '/orders/$orderId/edit'
    | '/purchasing/orders/$orderId'
    | '/purchasing/price-lists/$priceListId'
    | '/purchasing/receipts/$receiptId'
    | '/purchasing/requests/$requestId'
    | '/purchasing/requests/new'
    | '/purchasing/restock/levels'
    | '/recipes/costs/$productId'
    | '/replay/runs/$runId'
    | '/settings/held-actions/$holdId'
    | '/settings/rejected-actions/$commandId'
    | '/stock/counts/$countId'
    | '/orders/$orderId/'
    | '/purchasing/receipts/'
    | '/purchasing/requests/'
    | '/purchasing/restock/'
    | '/purchasing/suppliers/'
    | '/recipes/$recipeId/'
    | '/recipes/costs/'
    | '/settings/held-actions/'
    | '/settings/rejected-actions/'
    | '/stock/counts/'
    | '/imports/runs/$runId/records'
    | '/imports/runs/$runId/review'
    | '/recipes/$recipeId/versions/$versionId'
    | '/imports/runs/$runId/'
    | '/purchasing/suppliers/$supplierId/'
    | '/purchasing/suppliers/$supplierId/price-lists/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/design'
    | '/login'
    | '/approvals'
    | '/planning'
    | '/reports'
    | '/'
    | '/catalogue/$productId'
    | '/catalogue/review'
    | '/imports/connect'
    | '/imports/rules'
    | '/orders/new'
    | '/production/$batchId'
    | '/production/reports'
    | '/recipes/new'
    | '/replay/new'
    | '/sales/$ticketId'
    | '/settings/roles'
    | '/settings/staff'
    | '/settings/stations'
    | '/settings/stock-control'
    | '/stock/$productId'
    | '/stock/expiry'
    | '/stock/movements'
    | '/stock/write-offs'
    | '/catalogue'
    | '/imports'
    | '/orders'
    | '/production'
    | '/purchasing'
    | '/recipes'
    | '/replay'
    | '/sales'
    | '/settings'
    | '/stock'
    | '/orders/$orderId/edit'
    | '/purchasing/orders/$orderId'
    | '/purchasing/price-lists/$priceListId'
    | '/purchasing/receipts/$receiptId'
    | '/purchasing/requests/$requestId'
    | '/purchasing/requests/new'
    | '/purchasing/restock/levels'
    | '/recipes/costs/$productId'
    | '/replay/runs/$runId'
    | '/settings/held-actions/$holdId'
    | '/settings/rejected-actions/$commandId'
    | '/stock/counts/$countId'
    | '/orders/$orderId'
    | '/purchasing/receipts'
    | '/purchasing/requests'
    | '/purchasing/restock'
    | '/purchasing/suppliers'
    | '/recipes/$recipeId'
    | '/recipes/costs'
    | '/settings/held-actions'
    | '/settings/rejected-actions'
    | '/stock/counts'
    | '/imports/runs/$runId/records'
    | '/imports/runs/$runId/review'
    | '/recipes/$recipeId/versions/$versionId'
    | '/imports/runs/$runId'
    | '/purchasing/suppliers/$supplierId'
    | '/purchasing/suppliers/$supplierId/price-lists/new'
  id:
    | '__root__'
    | '/_app'
    | '/design'
    | '/login'
    | '/_app/approvals'
    | '/_app/planning'
    | '/_app/reports'
    | '/_app/'
    | '/_app/catalogue/$productId'
    | '/_app/catalogue/review'
    | '/_app/imports/connect'
    | '/_app/imports/rules'
    | '/_app/orders/new'
    | '/_app/production/$batchId'
    | '/_app/production/reports'
    | '/_app/recipes/new'
    | '/_app/replay/new'
    | '/_app/sales/$ticketId'
    | '/_app/settings/roles'
    | '/_app/settings/staff'
    | '/_app/settings/stations'
    | '/_app/settings/stock-control'
    | '/_app/stock/$productId'
    | '/_app/stock/expiry'
    | '/_app/stock/movements'
    | '/_app/stock/write-offs'
    | '/_app/catalogue/'
    | '/_app/imports/'
    | '/_app/orders/'
    | '/_app/production/'
    | '/_app/purchasing/'
    | '/_app/recipes/'
    | '/_app/replay/'
    | '/_app/sales/'
    | '/_app/settings/'
    | '/_app/stock/'
    | '/_app/orders/$orderId/edit'
    | '/_app/purchasing/orders/$orderId'
    | '/_app/purchasing/price-lists/$priceListId'
    | '/_app/purchasing/receipts/$receiptId'
    | '/_app/purchasing/requests/$requestId'
    | '/_app/purchasing/requests/new'
    | '/_app/purchasing/restock/levels'
    | '/_app/recipes/costs/$productId'
    | '/_app/replay/runs/$runId'
    | '/_app/settings/held-actions/$holdId'
    | '/_app/settings/rejected-actions/$commandId'
    | '/_app/stock/counts/$countId'
    | '/_app/orders/$orderId/'
    | '/_app/purchasing/receipts/'
    | '/_app/purchasing/requests/'
    | '/_app/purchasing/restock/'
    | '/_app/purchasing/suppliers/'
    | '/_app/recipes/$recipeId/'
    | '/_app/recipes/costs/'
    | '/_app/settings/held-actions/'
    | '/_app/settings/rejected-actions/'
    | '/_app/stock/counts/'
    | '/_app/imports/runs/$runId/records'
    | '/_app/imports/runs/$runId/review'
    | '/_app/recipes/$recipeId/versions/$versionId'
    | '/_app/imports/runs/$runId/'
    | '/_app/purchasing/suppliers/$supplierId/'
    | '/_app/purchasing/suppliers/$supplierId/price-lists/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  DesignRoute: typeof DesignRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design': {
      id: '/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof DesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals': {
      id: '/_app/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AppApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/planning': {
      id: '/_app/planning'
      path: '/planning'
      fullPath: '/planning'
      preLoaderRoute: typeof AppPlanningRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalogue/': {
      id: '/_app/catalogue/'
      path: '/catalogue'
      fullPath: '/catalogue/'
      preLoaderRoute: typeof AppCatalogueIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalogue/$productId': {
      id: '/_app/catalogue/$productId'
      path: '/catalogue/$productId'
      fullPath: '/catalogue/$productId'
      preLoaderRoute: typeof AppCatalogueProductIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/catalogue/review': {
      id: '/_app/catalogue/review'
      path: '/catalogue/review'
      fullPath: '/catalogue/review'
      preLoaderRoute: typeof AppCatalogueReviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports/': {
      id: '/_app/imports/'
      path: '/imports'
      fullPath: '/imports/'
      preLoaderRoute: typeof AppImportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports/connect': {
      id: '/_app/imports/connect'
      path: '/imports/connect'
      fullPath: '/imports/connect'
      preLoaderRoute: typeof AppImportsConnectRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports/rules': {
      id: '/_app/imports/rules'
      path: '/imports/rules'
      fullPath: '/imports/rules'
      preLoaderRoute: typeof AppImportsRulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/new': {
      id: '/_app/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AppOrdersNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/production/': {
      id: '/_app/production/'
      path: '/production'
      fullPath: '/production/'
      preLoaderRoute: typeof AppProductionIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/production/$batchId': {
      id: '/_app/production/$batchId'
      path: '/production/$batchId'
      fullPath: '/production/$batchId'
      preLoaderRoute: typeof AppProductionBatchIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/production/reports': {
      id: '/_app/production/reports'
      path: '/production/reports'
      fullPath: '/production/reports'
      preLoaderRoute: typeof AppProductionReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/': {
      id: '/_app/purchasing/'
      path: '/purchasing'
      fullPath: '/purchasing/'
      preLoaderRoute: typeof AppPurchasingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recipes/': {
      id: '/_app/recipes/'
      path: '/recipes'
      fullPath: '/recipes/'
      preLoaderRoute: typeof AppRecipesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recipes/new': {
      id: '/_app/recipes/new'
      path: '/recipes/new'
      fullPath: '/recipes/new'
      preLoaderRoute: typeof AppRecipesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/replay/': {
      id: '/_app/replay/'
      path: '/replay'
      fullPath: '/replay/'
      preLoaderRoute: typeof AppReplayIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/replay/new': {
      id: '/_app/replay/new'
      path: '/replay/new'
      fullPath: '/replay/new'
      preLoaderRoute: typeof AppReplayNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/': {
      id: '/_app/sales/'
      path: '/sales'
      fullPath: '/sales/'
      preLoaderRoute: typeof AppSalesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sales/$ticketId': {
      id: '/_app/sales/$ticketId'
      path: '/sales/$ticketId'
      fullPath: '/sales/$ticketId'
      preLoaderRoute: typeof AppSalesTicketIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/roles': {
      id: '/_app/settings/roles'
      path: '/settings/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AppSettingsRolesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/staff': {
      id: '/_app/settings/staff'
      path: '/settings/staff'
      fullPath: '/settings/staff'
      preLoaderRoute: typeof AppSettingsStaffRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/stations': {
      id: '/_app/settings/stations'
      path: '/settings/stations'
      fullPath: '/settings/stations'
      preLoaderRoute: typeof AppSettingsStationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/stock-control': {
      id: '/_app/settings/stock-control'
      path: '/settings/stock-control'
      fullPath: '/settings/stock-control'
      preLoaderRoute: typeof AppSettingsStockControlRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/': {
      id: '/_app/stock/'
      path: '/stock'
      fullPath: '/stock/'
      preLoaderRoute: typeof AppStockIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/$productId': {
      id: '/_app/stock/$productId'
      path: '/stock/$productId'
      fullPath: '/stock/$productId'
      preLoaderRoute: typeof AppStockProductIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/expiry': {
      id: '/_app/stock/expiry'
      path: '/stock/expiry'
      fullPath: '/stock/expiry'
      preLoaderRoute: typeof AppStockExpiryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/movements': {
      id: '/_app/stock/movements'
      path: '/stock/movements'
      fullPath: '/stock/movements'
      preLoaderRoute: typeof AppStockMovementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/write-offs': {
      id: '/_app/stock/write-offs'
      path: '/stock/write-offs'
      fullPath: '/stock/write-offs'
      preLoaderRoute: typeof AppStockWriteOffsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$orderId/': {
      id: '/_app/orders/$orderId/'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId/'
      preLoaderRoute: typeof AppOrdersOrderIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$orderId/edit': {
      id: '/_app/orders/$orderId/edit'
      path: '/orders/$orderId/edit'
      fullPath: '/orders/$orderId/edit'
      preLoaderRoute: typeof AppOrdersOrderIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/orders/$orderId': {
      id: '/_app/purchasing/orders/$orderId'
      path: '/purchasing/orders/$orderId'
      fullPath: '/purchasing/orders/$orderId'
      preLoaderRoute: typeof AppPurchasingOrdersOrderIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/price-lists/$priceListId': {
      id: '/_app/purchasing/price-lists/$priceListId'
      path: '/purchasing/price-lists/$priceListId'
      fullPath: '/purchasing/price-lists/$priceListId'
      preLoaderRoute: typeof AppPurchasingPriceListsPriceListIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/receipts/': {
      id: '/_app/purchasing/receipts/'
      path: '/purchasing/receipts'
      fullPath: '/purchasing/receipts/'
      preLoaderRoute: typeof AppPurchasingReceiptsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/receipts/$receiptId': {
      id: '/_app/purchasing/receipts/$receiptId'
      path: '/purchasing/receipts/$receiptId'
      fullPath: '/purchasing/receipts/$receiptId'
      preLoaderRoute: typeof AppPurchasingReceiptsReceiptIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/requests/': {
      id: '/_app/purchasing/requests/'
      path: '/purchasing/requests'
      fullPath: '/purchasing/requests/'
      preLoaderRoute: typeof AppPurchasingRequestsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/requests/$requestId': {
      id: '/_app/purchasing/requests/$requestId'
      path: '/purchasing/requests/$requestId'
      fullPath: '/purchasing/requests/$requestId'
      preLoaderRoute: typeof AppPurchasingRequestsRequestIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/requests/new': {
      id: '/_app/purchasing/requests/new'
      path: '/purchasing/requests/new'
      fullPath: '/purchasing/requests/new'
      preLoaderRoute: typeof AppPurchasingRequestsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/restock/': {
      id: '/_app/purchasing/restock/'
      path: '/purchasing/restock'
      fullPath: '/purchasing/restock/'
      preLoaderRoute: typeof AppPurchasingRestockIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/restock/levels': {
      id: '/_app/purchasing/restock/levels'
      path: '/purchasing/restock/levels'
      fullPath: '/purchasing/restock/levels'
      preLoaderRoute: typeof AppPurchasingRestockLevelsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/suppliers/': {
      id: '/_app/purchasing/suppliers/'
      path: '/purchasing/suppliers'
      fullPath: '/purchasing/suppliers/'
      preLoaderRoute: typeof AppPurchasingSuppliersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recipes/$recipeId/': {
      id: '/_app/recipes/$recipeId/'
      path: '/recipes/$recipeId'
      fullPath: '/recipes/$recipeId/'
      preLoaderRoute: typeof AppRecipesRecipeIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recipes/costs/': {
      id: '/_app/recipes/costs/'
      path: '/recipes/costs'
      fullPath: '/recipes/costs/'
      preLoaderRoute: typeof AppRecipesCostsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recipes/costs/$productId': {
      id: '/_app/recipes/costs/$productId'
      path: '/recipes/costs/$productId'
      fullPath: '/recipes/costs/$productId'
      preLoaderRoute: typeof AppRecipesCostsProductIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/replay/runs/$runId': {
      id: '/_app/replay/runs/$runId'
      path: '/replay/runs/$runId'
      fullPath: '/replay/runs/$runId'
      preLoaderRoute: typeof AppReplayRunsRunIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/held-actions/': {
      id: '/_app/settings/held-actions/'
      path: '/settings/held-actions'
      fullPath: '/settings/held-actions/'
      preLoaderRoute: typeof AppSettingsHeldActionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/held-actions/$holdId': {
      id: '/_app/settings/held-actions/$holdId'
      path: '/settings/held-actions/$holdId'
      fullPath: '/settings/held-actions/$holdId'
      preLoaderRoute: typeof AppSettingsHeldActionsHoldIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/rejected-actions/': {
      id: '/_app/settings/rejected-actions/'
      path: '/settings/rejected-actions'
      fullPath: '/settings/rejected-actions/'
      preLoaderRoute: typeof AppSettingsRejectedActionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/rejected-actions/$commandId': {
      id: '/_app/settings/rejected-actions/$commandId'
      path: '/settings/rejected-actions/$commandId'
      fullPath: '/settings/rejected-actions/$commandId'
      preLoaderRoute: typeof AppSettingsRejectedActionsCommandIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/counts/': {
      id: '/_app/stock/counts/'
      path: '/stock/counts'
      fullPath: '/stock/counts/'
      preLoaderRoute: typeof AppStockCountsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stock/counts/$countId': {
      id: '/_app/stock/counts/$countId'
      path: '/stock/counts/$countId'
      fullPath: '/stock/counts/$countId'
      preLoaderRoute: typeof AppStockCountsCountIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports/runs/$runId/': {
      id: '/_app/imports/runs/$runId/'
      path: '/imports/runs/$runId'
      fullPath: '/imports/runs/$runId/'
      preLoaderRoute: typeof AppImportsRunsRunIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports/runs/$runId/records': {
      id: '/_app/imports/runs/$runId/records'
      path: '/imports/runs/$runId/records'
      fullPath: '/imports/runs/$runId/records'
      preLoaderRoute: typeof AppImportsRunsRunIdRecordsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/imports/runs/$runId/review': {
      id: '/_app/imports/runs/$runId/review'
      path: '/imports/runs/$runId/review'
      fullPath: '/imports/runs/$runId/review'
      preLoaderRoute: typeof AppImportsRunsRunIdReviewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/suppliers/$supplierId/': {
      id: '/_app/purchasing/suppliers/$supplierId/'
      path: '/purchasing/suppliers/$supplierId'
      fullPath: '/purchasing/suppliers/$supplierId/'
      preLoaderRoute: typeof AppPurchasingSuppliersSupplierIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recipes/$recipeId/versions/$versionId': {
      id: '/_app/recipes/$recipeId/versions/$versionId'
      path: '/recipes/$recipeId/versions/$versionId'
      fullPath: '/recipes/$recipeId/versions/$versionId'
      preLoaderRoute: typeof AppRecipesRecipeIdVersionsVersionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/purchasing/suppliers/$supplierId/price-lists/new': {
      id: '/_app/purchasing/suppliers/$supplierId/price-lists/new'
      path: '/purchasing/suppliers/$supplierId/price-lists/new'
      fullPath: '/purchasing/suppliers/$supplierId/price-lists/new'
      preLoaderRoute: typeof AppPurchasingSuppliersSupplierIdPriceListsNewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppApprovalsRoute: typeof AppApprovalsRoute
  AppPlanningRoute: typeof AppPlanningRoute
  AppReportsRoute: typeof AppReportsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCatalogueProductIdRoute: typeof AppCatalogueProductIdRoute
  AppCatalogueReviewRoute: typeof AppCatalogueReviewRoute
  AppImportsConnectRoute: typeof AppImportsConnectRoute
  AppImportsRulesRoute: typeof AppImportsRulesRoute
  AppOrdersNewRoute: typeof AppOrdersNewRoute
  AppProductionBatchIdRoute: typeof AppProductionBatchIdRoute
  AppProductionReportsRoute: typeof AppProductionReportsRoute
  AppRecipesNewRoute: typeof AppRecipesNewRoute
  AppReplayNewRoute: typeof AppReplayNewRoute
  AppSalesTicketIdRoute: typeof AppSalesTicketIdRoute
  AppSettingsRolesRoute: typeof AppSettingsRolesRoute
  AppSettingsStaffRoute: typeof AppSettingsStaffRoute
  AppSettingsStationsRoute: typeof AppSettingsStationsRoute
  AppSettingsStockControlRoute: typeof AppSettingsStockControlRoute
  AppStockProductIdRoute: typeof AppStockProductIdRoute
  AppStockExpiryRoute: typeof AppStockExpiryRoute
  AppStockMovementsRoute: typeof AppStockMovementsRoute
  AppStockWriteOffsRoute: typeof AppStockWriteOffsRoute
  AppCatalogueIndexRoute: typeof AppCatalogueIndexRoute
  AppImportsIndexRoute: typeof AppImportsIndexRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
  AppProductionIndexRoute: typeof AppProductionIndexRoute
  AppPurchasingIndexRoute: typeof AppPurchasingIndexRoute
  AppRecipesIndexRoute: typeof AppRecipesIndexRoute
  AppReplayIndexRoute: typeof AppReplayIndexRoute
  AppSalesIndexRoute: typeof AppSalesIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppStockIndexRoute: typeof AppStockIndexRoute
  AppOrdersOrderIdEditRoute: typeof AppOrdersOrderIdEditRoute
  AppPurchasingOrdersOrderIdRoute: typeof AppPurchasingOrdersOrderIdRoute
  AppPurchasingPriceListsPriceListIdRoute: typeof AppPurchasingPriceListsPriceListIdRoute
  AppPurchasingReceiptsReceiptIdRoute: typeof AppPurchasingReceiptsReceiptIdRoute
  AppPurchasingRequestsRequestIdRoute: typeof AppPurchasingRequestsRequestIdRoute
  AppPurchasingRequestsNewRoute: typeof AppPurchasingRequestsNewRoute
  AppPurchasingRestockLevelsRoute: typeof AppPurchasingRestockLevelsRoute
  AppRecipesCostsProductIdRoute: typeof AppRecipesCostsProductIdRoute
  AppReplayRunsRunIdRoute: typeof AppReplayRunsRunIdRoute
  AppSettingsHeldActionsHoldIdRoute: typeof AppSettingsHeldActionsHoldIdRoute
  AppSettingsRejectedActionsCommandIdRoute: typeof AppSettingsRejectedActionsCommandIdRoute
  AppStockCountsCountIdRoute: typeof AppStockCountsCountIdRoute
  AppOrdersOrderIdIndexRoute: typeof AppOrdersOrderIdIndexRoute
  AppPurchasingReceiptsIndexRoute: typeof AppPurchasingReceiptsIndexRoute
  AppPurchasingRequestsIndexRoute: typeof AppPurchasingRequestsIndexRoute
  AppPurchasingRestockIndexRoute: typeof AppPurchasingRestockIndexRoute
  AppPurchasingSuppliersIndexRoute: typeof AppPurchasingSuppliersIndexRoute
  AppRecipesRecipeIdIndexRoute: typeof AppRecipesRecipeIdIndexRoute
  AppRecipesCostsIndexRoute: typeof AppRecipesCostsIndexRoute
  AppSettingsHeldActionsIndexRoute: typeof AppSettingsHeldActionsIndexRoute
  AppSettingsRejectedActionsIndexRoute: typeof AppSettingsRejectedActionsIndexRoute
  AppStockCountsIndexRoute: typeof AppStockCountsIndexRoute
  AppImportsRunsRunIdRecordsRoute: typeof AppImportsRunsRunIdRecordsRoute
  AppImportsRunsRunIdReviewRoute: typeof AppImportsRunsRunIdReviewRoute
  AppRecipesRecipeIdVersionsVersionIdRoute: typeof AppRecipesRecipeIdVersionsVersionIdRoute
  AppImportsRunsRunIdIndexRoute: typeof AppImportsRunsRunIdIndexRoute
  AppPurchasingSuppliersSupplierIdIndexRoute: typeof AppPurchasingSuppliersSupplierIdIndexRoute
  AppPurchasingSuppliersSupplierIdPriceListsNewRoute: typeof AppPurchasingSuppliersSupplierIdPriceListsNewRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppApprovalsRoute: AppApprovalsRoute,
  AppPlanningRoute: AppPlanningRoute,
  AppReportsRoute: AppReportsRoute,
  AppIndexRoute: AppIndexRoute,
  AppCatalogueProductIdRoute: AppCatalogueProductIdRoute,
  AppCatalogueReviewRoute: AppCatalogueReviewRoute,
  AppImportsConnectRoute: AppImportsConnectRoute,
  AppImportsRulesRoute: AppImportsRulesRoute,
  AppOrdersNewRoute: AppOrdersNewRoute,
  AppProductionBatchIdRoute: AppProductionBatchIdRoute,
  AppProductionReportsRoute: AppProductionReportsRoute,
  AppRecipesNewRoute: AppRecipesNewRoute,
  AppReplayNewRoute: AppReplayNewRoute,
  AppSalesTicketIdRoute: AppSalesTicketIdRoute,
  AppSettingsRolesRoute: AppSettingsRolesRoute,
  AppSettingsStaffRoute: AppSettingsStaffRoute,
  AppSettingsStationsRoute: AppSettingsStationsRoute,
  AppSettingsStockControlRoute: AppSettingsStockControlRoute,
  AppStockProductIdRoute: AppStockProductIdRoute,
  AppStockExpiryRoute: AppStockExpiryRoute,
  AppStockMovementsRoute: AppStockMovementsRoute,
  AppStockWriteOffsRoute: AppStockWriteOffsRoute,
  AppCatalogueIndexRoute: AppCatalogueIndexRoute,
  AppImportsIndexRoute: AppImportsIndexRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
  AppProductionIndexRoute: AppProductionIndexRoute,
  AppPurchasingIndexRoute: AppPurchasingIndexRoute,
  AppRecipesIndexRoute: AppRecipesIndexRoute,
  AppReplayIndexRoute: AppReplayIndexRoute,
  AppSalesIndexRoute: AppSalesIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppStockIndexRoute: AppStockIndexRoute,
  AppOrdersOrderIdEditRoute: AppOrdersOrderIdEditRoute,
  AppPurchasingOrdersOrderIdRoute: AppPurchasingOrdersOrderIdRoute,
  AppPurchasingPriceListsPriceListIdRoute:
    AppPurchasingPriceListsPriceListIdRoute,
  AppPurchasingReceiptsReceiptIdRoute: AppPurchasingReceiptsReceiptIdRoute,
  AppPurchasingRequestsRequestIdRoute: AppPurchasingRequestsRequestIdRoute,
  AppPurchasingRequestsNewRoute: AppPurchasingRequestsNewRoute,
  AppPurchasingRestockLevelsRoute: AppPurchasingRestockLevelsRoute,
  AppRecipesCostsProductIdRoute: AppRecipesCostsProductIdRoute,
  AppReplayRunsRunIdRoute: AppReplayRunsRunIdRoute,
  AppSettingsHeldActionsHoldIdRoute: AppSettingsHeldActionsHoldIdRoute,
  AppSettingsRejectedActionsCommandIdRoute:
    AppSettingsRejectedActionsCommandIdRoute,
  AppStockCountsCountIdRoute: AppStockCountsCountIdRoute,
  AppOrdersOrderIdIndexRoute: AppOrdersOrderIdIndexRoute,
  AppPurchasingReceiptsIndexRoute: AppPurchasingReceiptsIndexRoute,
  AppPurchasingRequestsIndexRoute: AppPurchasingRequestsIndexRoute,
  AppPurchasingRestockIndexRoute: AppPurchasingRestockIndexRoute,
  AppPurchasingSuppliersIndexRoute: AppPurchasingSuppliersIndexRoute,
  AppRecipesRecipeIdIndexRoute: AppRecipesRecipeIdIndexRoute,
  AppRecipesCostsIndexRoute: AppRecipesCostsIndexRoute,
  AppSettingsHeldActionsIndexRoute: AppSettingsHeldActionsIndexRoute,
  AppSettingsRejectedActionsIndexRoute: AppSettingsRejectedActionsIndexRoute,
  AppStockCountsIndexRoute: AppStockCountsIndexRoute,
  AppImportsRunsRunIdRecordsRoute: AppImportsRunsRunIdRecordsRoute,
  AppImportsRunsRunIdReviewRoute: AppImportsRunsRunIdReviewRoute,
  AppRecipesRecipeIdVersionsVersionIdRoute:
    AppRecipesRecipeIdVersionsVersionIdRoute,
  AppImportsRunsRunIdIndexRoute: AppImportsRunsRunIdIndexRoute,
  AppPurchasingSuppliersSupplierIdIndexRoute:
    AppPurchasingSuppliersSupplierIdIndexRoute,
  AppPurchasingSuppliersSupplierIdPriceListsNewRoute:
    AppPurchasingSuppliersSupplierIdPriceListsNewRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  DesignRoute: DesignRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
